/**
 * @namespace Breadcrumb
 */
SWRNEU.Breadcrumb = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'breadcrumb';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '.breadcrumb'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Breadcrumb = function () {
    function Breadcrumb(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.$element.closest('.row').before(self.$element);
      self.$element.next().remove();

      self.simpleSlider = new SWRNEU.SimpleSlider({
        sliderList: self.$element,
        wrapperClass: 'breadcrumb-wrapper',
        ariaLabel: 'Zusatznavigation',
        buttonLabelPrev: 'Zusatznavigation zurück blättern',
        buttonLabelNext: 'Zusatznavigation weiter blättern'
      });
    }

    // public
    Breadcrumb.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Breadcrumb._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Breadcrumb(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Breadcrumb;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Breadcrumb._jQueryInterface.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Breadcrumb._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Breadcrumb._jQueryInterface;
  $.fn[NAME].Constructor = Breadcrumb;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Breadcrumb._jQueryInterface;
  };

  return Breadcrumb;

}(window.jQuery);
